import React from "react";
import { connect } from "react-redux";
import { HashRouter as Router, Route, Switch } from "react-router-dom";

import { fetchDrinks, setDrinksFilter } from "../actions";
import Header from "./Header";
import DrinksGrid from "./drinks/DrinksGrid";
import DrinkDetail from "./drinks/DrinkDetail";
import Spinner from "./Spinner";

class App extends React.Component {
  state = { filteredDrinks: [] };

  componentDidMount() {
    this.props.fetchDrinks();
  }

  onSearch = searchTerm => {
    this.props.setDrinksFilter(searchTerm);
  };

  getVisibleDrinks = (drinks, filter) => {
    if (!filter) {
      return drinks;
    }

    return drinks.filter(drink => {
      const cleanName = drink.name.toLowerCase().trim();
      const cleanFilter = filter.toLowerCase().trim();
      return cleanName.includes(cleanFilter);
    });
  };

  renderHeader = () => {
    const links = (
      <div>
        <a href="https://www.gosuraj.com/projects/hdm-react/" className="item">
          About
        </a>
      </div>
    );

    return (
      <Header
        title="Hot Drinks Machine React"
        links={links}
        search
        onSearchSubmit={this.onSearch}
        onSearchChange={this.onSearch}
      />
    );
  };

  renderDrinksGrid = () => {
    let { drinks, drinksFilter } = this.props;
    if (drinks.length < 1) {
      return <Spinner />;
    }

    return <DrinksGrid drinks={this.getVisibleDrinks(drinks, drinksFilter)} />;
  };

  render() {
    return (
      <div className="ui container">
        <Router>
          {this.renderHeader()}
          <div>
            <Switch>
              <Route path="/" exact component={this.renderDrinksGrid} />
              <Route path="/drinks/:id" component={DrinkDetail} />
            </Switch>
          </div>
        </Router>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    drinks: state.drinks,
    drinksFilter: state.drinksFilter
  };
};

const mapActionsToProps = { fetchDrinks, setDrinksFilter };

export default connect(
  mapStateToProps,
  mapActionsToProps
)(App);
